export const checkErrorStatus = (error) =>
	error.response && error.response.status !== 401;
